import { mapState, mapGetters, mapMutations } from "vuex";
import moment from "moment";
import anime from "animejs/lib/anime.es.js"
import apiHelper from "@/helpers/apiHelper"
import UAParser from "ua-parser-js";
import store from "@/store/index";
import businessLogic from "@/helpers/businessLogic"

export default {
    data: () => ({
        serviceNotAvailable: false,
        appVersion: "1.0.0",
        publicPath: process.env.BASE_URL,
        areaImagePath: process.env.BASE_URL + "img/areas/",
        branchImagePath: process.env.BASE_URL + "img/branches/",
        audioPath: process.env.BASE_URL + "audio/",
        iconPath: process.env.BASE_URL + "img/icons/",
    }),
    computed: {
        ...mapState(["time", "branchMenus", "settings", "accountInfo"]),
        ...mapGetters(["authenticated", "onsiteMode"]),
        windowSettings() {
            return window.$settings;
        },
        primaryColor() {
            return this.$vuetify.theme.themes.light.primary;
        }
    },
    methods: {
        ...mapMutations(["updateLoading", "updateResult", "updateSystemDialog", "updateSystemAlert"]),
        haha() {
            alert("haha!")
        },
        getTime() {
            // const now = window.$settings.mockDateString ? new Date(window.$settings.mockDateString) : new Date()
            const nowMoment = moment(window.$settings.mockDateString);
            const todayMoment = moment(nowMoment.format("YYYY-MM-DD"));

            return {
                nowMoment, todayMoment
            };
        },
        clone(obj) {
            return JSON.parse(JSON.stringify(obj));
        },
        isMobileDevice() {
            const uaParser = new UAParser();
            const result = uaParser.getResult();

            // //TODO: Remove this
            // if (!window.$notFirstIsMobileDeviceCheck) {
            //     console.debug("UA info", result)
            //     window.$notFirstIsMobileDeviceCheck = true;
            // }

            return result && result.device && result.device.type && (result.device.type === "mobile" || result.device.type === "tablet")
        },
        isUnsupportedBrowser() {
            const uaParser = new UAParser();
            const result = uaParser.getResult();

            return result && result.browser && result.browser.name === "IE"
        },
        android() {
            return /Android/i.test(window.navigator.userAgent)
        },
        isInStandaloneMode() {
            return (window.matchMedia('(display-mode: standalone)').matches) || (window.navigator.standalone) || document.referrer.includes('android-app://')
        },
        isMobileOrStandaloneMode() {
            return this.isInStandaloneMode() || this.isMobileDevice()
        },
        heights() {
            return {
                screen: document.documentElement.clientHeight,
                toolbar: 56,
                toolbarWithButtons: 56 + 34 + 8 + 2,
                tabbar: 41,
                headerbar: 41,
                bottombar: 48,
                noticeBarHeight: 85,
            }
        },
        screenHeight() {
            return document.documentElement.clientHeight
        },
        screenHeights() {
            return {
                windowInnerHeight: window.innerHeight,
                windowScreenHeight: window.screen.height,
                docClientHeight: document.documentElement.clientHeight,
                docScrollHeight: document.documentElement.scrollHeight
            }
        },
        bottomNavigationHeight() {
            const bottomNavigationHeight = document
                .getElementById("bottomNavigation")
                .getBoundingClientRect().height;

            return 48// bottomNavigationHeight
        },
        auth(currentRouteName) {
            if (!this.authenticated) {
                apiHelper.casAuth(currentRouteName);
            }
            else {
                this.$router.push({ name: "Account" })
            }
        },
        logout() {
            businessLogic.logout()
        },
        setThemeColorByMode(duration) {
            //TODO: Remember to roll back
            let themeColor = this.onsiteMode ? "#0047BB" : "#0047BB"
            // themeColor = "#1976D2"; (archived) (if onsiteMode)
            // themeColor = "#00796B"; (archived)
            this.setPrimaryColor(themeColor)

            if (this.$route.name === "Help") {
                console.log('hi');
                themeColor = this.onsiteMode ? "#0047BB" : "#0047BB";
                // themeColor = "#0d47a1"; (archived) (if onsiteMode)
                // themeColor = "#004d40"; (archived)
            }

            this.setStatusBackgroundBarColor(themeColor, duration)
        },
        setPrimaryColor(color, secondary) {
            this.$vuetify.theme.themes.light.primary = color;
            this.$vuetify.theme.themes.light.secondary = secondary;
        },
        setStatusBackgroundBarColor(color, duration) {
            const metaThemeColor = document.getElementById("metaThemeColor").getAttribute("content")

            anime({
                targets: '.metaThemeColor',
                content: [metaThemeColor, color],
                duration: duration || 0,
                easing: 'easeOutCirc'
            });

            // anime({
            //     targets: '.metaThemeColor',
            //     content: [metaThemeColor, color],
            //     duration: duration || 200,
            //     easing: 'easeOutCirc'
            // });
        },
        goBack() {
            window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
        },
        goHome() {
            this.$router.push("/")
        },
        convertQueryStringToObj(url) {
            if (url) {
                const queryStringIndex = url.indexOf("?")
                if (queryStringIndex >= 0 && url.length > 1) {
                    const queryStringUrl = url.substring(queryStringIndex + 1)
                    return Object.fromEntries(new URLSearchParams(queryStringUrl))
                }
            }

            return null
        },
        windowInfo() {
            const a = {
                width: document.documentElement.clientWidth,
                height: document.documentElement.clientHeight,
                min: Math.min(document.documentElement.clientWidth, document.documentElement.clientHeight),
                max: Math.max(document.documentElement.clientWidth, document.documentElement.clientHeight)
            }

            return a;
        },
        commonResponseHandler(response, successMessage, errorMessage,
            alwaysCallback, successCallback, errorCallback, hideResult) {

            return businessLogic.commonResponseHandler(response, successMessage, errorMessage,
                alwaysCallback, successCallback, errorCallback, hideResult)
        }
    }
}